import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import "./CSS/themes.css";
import "./CSS/leetcode.css";

import Layout from "./components/layout/Layout";
import Badges from "./pages/Badges";
import ContactPage from "./pages/ContactPage";
import Dashboard from "./pages/Dashboard";
import Experience from "./pages/Experience";
import Gallery from "./pages/Gallery";
import ProblemDetail from "./pages/ProblemDetail";
import Problems from "./pages/Problems";
import ResumePage from "./pages/ResumePage";
import Topics from "./pages/Topics";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="problems" element={<Problems />} />
          <Route path="problems/:slug" element={<ProblemDetail />} />
          <Route path="experience" element={<Experience />} />
          <Route path="topics" element={<Topics />} />
          <Route path="badges" element={<Badges />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="resume" element={<ResumePage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
